/*
 * @Author: JettyHuang
 * @LastEditors: JettyHuang
 * @Description:
 * @Date: 2021-03-03 18:15:48
 * @LastEditTime: 2021-04-27 14:02:05
 * @FilePath: /yft-b2c-web-h5/src/pages/Store/Wallet/StoreWallet/StoreWallettMod.js
 */
import { observable, action, flow } from 'mobx';
import Stores from 'config/Stores';
import Serv from './StoreWalletServ';

class StoreWalletMod {
  @observable storeList = [
    { id: Stores.AppMod.userInfo.id, userName: (Stores.AppMod.isHiddenShop ? '店铺' : '') + '钱包' }
  ]; // 子账号列表

  @observable storeIndex = 0; // 钱包视角索引（0是店铺视角，大于0是子账号视角）

  @observable walletBalance = 0; // 钱包余额

  @observable chargeAmountSum = 0; // 累计充值金额

  @observable latestTransaction = null; // 最新一项明细

  @action
  changeState(obj) {
    Object.keys(obj).forEach((key) => {
      this[key] = obj[key];
    });
  }

  /**
   * 获取子账号列表
   */
  getAccountList = flow(function* () {
    try {
      const { data } = yield Serv.getAccountList({ pageNum: 1, pageSize: 10 });
      if (Array.isArray(data.list)) {
        this.storeList = [
          {
            id: Stores.AppMod.userInfo.id,
            userName: (Stores.AppMod.isHiddenShop ? '店铺' : '') + '钱包'
          }
        ].concat(
          data.list.map((item) => ({
            ...item,
            storeNum: item.userName,
            userName: `子账号${item.userName}钱包`
          }))
        );
      }
    } catch (error) {}
  });

  /**
   * 获取钱包信息
   */
  getWalletInfo = flow(function* () {
    try {
      const { data } = yield Serv.getWalletInfo();
      if (Array.isArray(data)) {
        let info = data.find((item) => item.accountType == 'SHOP');
        if (info) {
          this.walletBalance = info.balance;
          this.chargeAmountSum = info.chargeAmountSum;
        }
      }
    } catch (error) {}
  });

  /**
   * 店长查子账号钱包余额
   */
  getSubAccountWalletInfo = flow(function* () {
    try {
      const subAccountId = this.storeList[this.storeIndex].id;
      if (!subAccountId) return;
      const { data } = yield Serv.getSubAccountWalletInfo(subAccountId);
      if (data) {
        this.walletBalance = data.usefulBalance || 0;
      }
    } catch (error) {}
  });

  /**
   * 获取最新一项明细
   */
  getLatestTransaction = flow(function* () {
    const pageSize = 1;
    const pageNum = 1;
    const params = {
      accountTypeList: ['SHOP'],
      flowType: ''
    };
    if (this.storeIndex > 0) {
      params.userId = this.storeList[this.storeIndex].id;
    }
    try {
      const { data } = yield Serv.getLatestTransaction(pageSize, pageNum, params);
      if (data && data.list) {
        this.latestTransaction = data.list[0];
      }
    } catch (error) {}
  });

  @action
  clearData() {
    this.storeList = [
      {
        id: Stores.AppMod.userInfo.id,
        userName: (Stores.AppMod.isHiddenShop ? '店铺' : '') + '钱包'
      }
    ];
    this.storeIndex = 0;
    this.walletBalance = 0;
    this.latestTransaction = null;
  }
}

const storeWalletMod = new StoreWalletMod();
export default storeWalletMod;



// WEBPACK FOOTER //
// ./src/pages/Store/Wallet/StoreWallet/StoreWallettMod.js